import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableBasePropRows = makeShortcode("PropsTableBasePropRows");
const Link = makeShortcode("Link");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {BranchName} from '@primer/react'
`}</code></pre>
    <p>{`BranchName is a label-type component rendered as an `}<inlineCode parentName="p">{`<a>`}</inlineCode>{` tag by default with monospace font.`}</p>
    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<BranchName href="#">a_new_feature_branch</BranchName>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`BranchName`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableBasePropRows elementType="a" refType="HTMLAnchorElement" isPolymorphic passthroughPropsLink={<Link href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes" mdxType="Link">MDN</Link>} mdxType="PropsTableBasePropRows" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: false,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      